import { Component, Inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MediaType } from '../../../../constants/constants';


@Component({
    selector: 'directCall-media-preview',
    imports: [MatButtonModule, TranslateModule],
    templateUrl: './media-preview.component.html',
    styleUrls: ['./media-preview.component.scss']
})
export class MediaPreviewComponent {

  url: string;
  mediaType: MediaType;
  mediaTypeEnum = MediaType;

  constructor(
    public dialogRef: MatDialogRef<MediaPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.url = data.url;
    this.mediaType = data.mediaType;
  }
 
  close(): void {
    this.dialogRef.close();
  }

}

